// import {errorHandler, logout, message, loader} from '@/libs/helper'
import {getOganisationById , getOrganisationsTeam } from '@/libs/api/api'
// import pageRoute from '@/libs/constant/pageRoutes'

export default {
    name :'IamDashboard',
    data(){
        return {
            selectedOrganisation:{},
            metaList:[],
            orgCompleteDetails:{},
            allOrganisations:[],
            organisationTeams:[],
            loadObj:{
                id:false,
                alias:false,
                user:false,
                teams:false,
                user_groups:false,
                roles: false,
            },
            organisationGroups:{}
            }
        },
    props:{
        allOrgnisations:Array,
        currentOrganisation:Object,
    },
    watch: { 
        currentOrganisation: function(newVal) {
        this.selectedOrganisation=newVal || {}  
     },
     allOrganisations:function(newVal){
        this.allOrganisations=newVal || []
     },
    },
beforeMount(){
    this.loadObj.id=true
    this.loadObj.alias=true
    this.selectedOrganisation={...this.currentOrganisation}
    if(this.selectedOrganisation)
    {
        this.loadObj.id=false
        this.loadObj.alias=false
    }
},
async mounted(){
    this.loadObj.teams=true
    this.loadObj.user=true
    this.loadObj.user_groups=true
    this.loadObj.roles = true
    await this.fetchorgnisationDetail();
    await this.fetchOrganisationTeams();
},
    methods:{
    
        async fetchorgnisationDetail(){
                try {
                    let id = this.selectedOrganisation && this.selectedOrganisation._id || this.currentOrganisation && this.currentOrganisation._id
                    let response = await getOganisationById(id)
                    this.orgCompleteDetails = response || {} 
                    this.loadObj.user=false
                    this.loadObj.user_groups=false
                    this.loadObj.roles = false
                } catch (error) {
                    console.error(error)
                    this.loadObj.user=false
                    this.loadObj.user_groups=false
                    this.loadObj.roles = false
                }
        },
        async fetchOrganisationTeams(){
                let organisation = this.selectedOrganisation && this.selectedOrganisation._id || this.currentOrganisation && this.currentOrganisation._id
                let payload ={organisation: organisation}
                await getOrganisationsTeam(payload).then((response)=>{
                this.organisationTeams=response.items || [];
                this.loadObj.teams=false
                }
            ).catch((error)=>{
                    console.log(error);
                    this.organisationTeams=[]
                    this.loadObj.teams=false
            })
        },
        routeTo(pageName) {
            this.$router.push({name: pageName})
        }
    }
}